// Simple countUp.js implementation
// Require countup.js
const CountUp = require('countup.js').CountUp;

const Stats = {
	init: function () {
		try {
			const statItems = document.querySelectorAll('.stat-item__number');

			if (statItems.length === 0) return;

			statItems.forEach((item) => {
				// Get the target value
				const value = parseFloat(item.getAttribute('data-value').replace(/,/g, ''));
				if (isNaN(value)) return;

				// Determine if integer or decimal
				const decimalPlaces = Number.isInteger(value) ? 0 : 1;

				// Simple configuration
				const options = {
					startVal: 0,
					decimalPlaces: decimalPlaces,
					duration: 2.5,
					useEasing: true,
					useGrouping: true,
					enableScrollSpy: true,
				};

				// Create the counter
				try {
					const countUp = new CountUp(item, value, options);
					if (!countUp.error) {
						// With enableScrollSpy:true, no need to manually start()
						// But we can handle any errors
					} else {
						console.error('CountUp error:', countUp.error);
					}
				} catch (e) {
					console.error('Error creating counter:', e);
				}
			});
		} catch (e) {
			console.error('Error in stats initialization:', e);
		}
	},
};

module.exports = Stats;
